import React, { useState } from 'react';
import { Button, Modal, Steps, Row, Col, Form } from 'antd';
import { useTranslation } from 'react-i18next';
import MassiveChargeStep1 from './MassiveChargeStep1';
import MassiveChargeStep2 from './MassiveChargeStep2';
import MassiveChargeStep3 from './MassiveChargeStep3';
import MassiveChargeStep4 from './MassiveChargeStep4';

const { Step } = Steps;

const fieldsToInclude = [
  { key: 'documentType', mandatory: true },
  { key: 'documentNumber', mandatory: true },
  { key: 'names', mandatory: true },
  { key: 'lastnames', mandatory: true },
  { key: 'protocol', mandatory: true },
  { key: 'applicant', mandatory: true },
  { key: 'evaluationType', mandatory: true },
  { key: 'jobPosition', mandatory: true },
  { key: 'reservationDate', mandatory: true },
  { key: 'phone', mandatory: false },
  { key: 'email', mandatory: false },
  { key: 'externalId', mandatory: false },
  { key: 'costCenter', mandatory: false },
  { key: 'project', mandatory: false },
  { key: 'area', mandatory: false },
  { key: 'birthDate', mandatory: false },
  { key: 'gender', mandatory: false },
];

const MassiveCharge = () => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [form] = Form.useForm();
  const [mappingData, setMappingData] = useState(null);
  const [finalDataSource, setFinalDataSource] = useState([]);
  const [baseData, setBaseData] = useState({});
  const [overCapacityToken, setOverCapacityToken] = useState(null);
  const { t } = useTranslation();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentStep(0);
    form.resetFields();
  };

  return (
    <>
      <Button
        className="cmt-button primary"
        type="primary"
        size="large"
        block
        onClick={showModal}
      >
        {t('reservations.massiveCharge.button')}
      </Button>
      <Modal
        open={isModalVisible}
        onCancel={handleCancel}
        footer={null}
        destroyOnClose
        width="80vw"
        className="massive-charge-modal"
        closable
      >
        <div className="massive-charge-container">
          <Row justify="center">
            <Col span={24}>
              <h2 className="massive-charge-modal__title">
                {t('reservations.massiveCharge.modalTitle')}
              </h2>
            </Col>
            <Col lg={20} xs={24} className="steps-wrapper">
              <Steps
                current={currentStep}
                direction="horizontal"
                responsive={false}
              >
                <Step title={t('reservations.massiveCharge.step1')} />
                <Step title={t('reservations.massiveCharge.step2')} />
                <Step title={t('reservations.massiveCharge.step3')} />
                <Step title={t('reservations.massiveCharge.step4')} />
              </Steps>
            </Col>
          </Row>
          <div className="massive-charge-content">
            {currentStep === 0 && (
              <MassiveChargeStep1 
                form={form} 
                setCurrentStep={setCurrentStep} 
                fieldsToInclude={fieldsToInclude}
                setBaseData={setBaseData}
              />
            )}
            {currentStep === 1 && (
              <MassiveChargeStep2 
                form={form}
                setCurrentStep={setCurrentStep} 
                fieldsToInclude={fieldsToInclude}
                onMappingComplete={(data) => setMappingData(data)}
              />
            )}
            {currentStep === 2 && (
              <MassiveChargeStep3 
                form={form}
                setCurrentStep={setCurrentStep} 
                fieldsToInclude={fieldsToInclude}
                mappingData={mappingData}
                setFinalDataSource={setFinalDataSource}
                baseData={baseData}
                setOverCapacityToken={setOverCapacityToken}
              />
            )}
            {currentStep === 3 && (
              <MassiveChargeStep4
                form={form}
                handleCancel={handleCancel}
                finalDataSource={finalDataSource}
                baseData={baseData}
                overCapacityToken={overCapacityToken}
                fieldsToInclude={fieldsToInclude}
              />
            )}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default MassiveCharge;
